import { CONSTANTS__generation_settings } from '@shared/constants/CONSTANTS__generation_settings';
import { CONSTANTS_GENERATION__slider_step } from '@shared/constants/CONSTANTS_GENERATION__slider_step';
import { CONSTANTS_GENERATION__value_range } from '@shared/constants/CONSTANTS_GENERATION__value_range';
import { ENUM__control_net_type, ENUM_UTILS__control_net_type } from '@shared/dto/+model/sd/_enums/ENUM__control_net_type';
import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { MAP__fields_by_role } from '@shared/types/types';
import { ENUM__control_net_mode } from '../../../_enums/ENUM__control_net_mode';
import { DTO_GRAPH__instance } from '../../../_graph/DTO_GRAPH__instance';
import { ENUM__field_connectable_type } from '../../_base/_methods/ENUM__field_connectable_type';
import { FIELD__base } from '../../_base/FIELD__base';
import { FIELD__base_visible_connectable } from '../../_base/FIELD__base_connectable';
import { DECORATOR__class_serialization_tested } from '../../_primitives/_base/DECORATOR__class_serialization_tested';
import { DECORATOR__class_serialization_tested_for_hash } from '../../_primitives/_base/DECORATOR__class_serialization_tested_for_hash';
import { DECORATOR__field_is_input } from '../../_primitives/_base/DECORATOR__field_is_input';
import { DECORATOR__field_not_linked } from '../../_primitives/_base/DECORATOR__field_not_linked';
import { FIELD_PRIMITIVE__float } from '../../_primitives/number/FIELD_PRIMITIVE__float';
import { FIELD_PRIMITIVE__string_enum } from '../../_primitives/string/FIELD_PRIMITIVE__string_enum';
import { FIELD_PRIMITIVE__string_hash_ml_asset } from '../../_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';
import { ENUM__image_asset_category } from '../../ENUM__image_asset_category';
import { FIELD__image_asset } from '../../image/FIELD__image_asset';

@DECORATOR__class_serialization_tested
@DECORATOR__class_serialization_tested_for_hash
export class FIELD__ml_asset_control_net extends FIELD__base_visible_connectable {
  /*
   * STATIC FIELDS
   */
  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_ML_ASSET_CONTROL_NET;

  /*
   *
   */
  static sort_by_hash(a: FIELD__ml_asset_control_net, b: FIELD__ml_asset_control_net) {
    let hash_a = a.model.get_value();
    let hash_b = b.model.get_value();

    return hash_a.localeCompare(hash_b);
  }

  /*
   * FIELDS
   */
  @FIELD_PRIMITIVE__string_enum.register_input__enum(ENUM__control_net_type.LINE_GUIDANCE_CANNY, ENUM__control_net_type, {
    grid2d__can_be_dimension: false,
    ui__has_component: false,
  })
  type!: FIELD_PRIMITIVE__string_enum;

  @FIELD__image_asset.init_as_field_transform_stretch({ category: ENUM__image_asset_category.LINE__CANNY })
  image!: FIELD__image_asset;

  @FIELD_PRIMITIVE__string_hash_ml_asset.init_field_with_type(ENUM__ml_asset_type.CONTROL_NET)
  model!: FIELD_PRIMITIVE__string_hash_ml_asset;
  // tood:use
  //todo: use list of floats. list.length = denoise steps
  @FIELD_PRIMITIVE__float.init_as_field(
    {
      value: 0.5,
      value_range: CONSTANTS_GENERATION__value_range.WEIGHT_RANGE,
      values_allowed: CONSTANTS_GENERATION__value_range.WEIGHT_ALLOWED,
      //
      slider_step: CONSTANTS_GENERATION__slider_step.WEIGHT_DEFAULT,
      slider_step_values: CONSTANTS_GENERATION__slider_step.WEIGHT_VALUES,
    },
    { generation__dynamic_duration: true },
  )
  weight!: FIELD_PRIMITIVE__float;

  @FIELD_PRIMITIVE__float.init_as_field(CONSTANTS__generation_settings.PARAMS_STEPS_BEGIN, {
    generation__dynamic_duration: true,
  })
  step_percent_begin!: FIELD_PRIMITIVE__float;

  @FIELD_PRIMITIVE__float.init_as_field(CONSTANTS__generation_settings.PARAMS_STEPS_END, {
    generation__dynamic_duration: true,
  })
  step_percent_end!: FIELD_PRIMITIVE__float;

  @FIELD_PRIMITIVE__string_enum.register_input__enum(ENUM__control_net_mode.BALANCED, ENUM__control_net_mode, {})
  control_mode!: FIELD_PRIMITIVE__string_enum;

  /*
   * PROPERTIES
   */

  field_connectable__type() {
    return ENUM__field_connectable_type.ML_ASSET__CONTROL_NET;
  }

  field_connectable__value(graph: DTO_GRAPH__instance): string {
    return this.meta.field_hash__value_full;
  }

  @DECORATOR__field_not_linked()
  has_effect_on_generation_runtime(graph: DTO_GRAPH__instance) {
    // todo: use find_source
    if (!this.image.get_has_content()) return false;
    if (this.image.asset_original__is_single_color) return false;
    if (this.weight.get_value() == 0) return false;
    if (this.step_percent_begin.get_value() == this.step_percent_end.get_value()) return false;

    return super.has_effect_on_generation_runtime(graph);
  }

  /*
   * METHODS
   */

  post_init(): void {
    super.post_init();
  }

  prepare_for_usage_in(graph: DTO_GRAPH__instance) {
    super.prepare_for_usage_in(graph);

    /*
     * STEP PERCENT
     */

    this.step_percent_begin.sync_with_field_max(this.step_percent_end);

    /*
     * IMAGE CATEGORY
     */
    let control_net_type = this.type.get_value_enum(ENUM__control_net_type);

    let valid_category = ENUM_UTILS__control_net_type.get_image_category_for(control_net_type);

    let category_was_canged = this.image.category != valid_category;

    this.image.category = valid_category;

    /*
     * IMAGE CONTENT
     */

    if (!this.image.get_has_content()) return; //no need to reset image
    // todo: mb need replace with all synced fields
    if (!category_was_canged) return; //category was not changed
    if (this.image.hash_sha256_content.is_empty_hash_sha256()) return; //no need to reset empty image

    /*
     *
     */

    this.image.image__clear();
    graph.field__replace(this.image);

    /*
     *
     */
  }

  update_fields_aliases(fields_map: MAP__fields_by_role) {
    super.update_fields_aliases(fields_map);

    let type = this.type.get_value_enum(ENUM__control_net_type);

    this.try_set_field_role(fields_map, this.model, `🎛️ Ctrl "${type}" Model`);
    this.try_set_field_role(fields_map, this.weight, `🎛️ Ctrl "${type}" Weight`);
    this.try_set_field_role(fields_map, this.image, `🎛️ Ctrl "${type}" Image`);

    this.try_set_field_role(fields_map, this.step_percent_begin, `🏁 Ctrl "${type}" Step % Begin`);
    this.try_set_field_role(fields_map, this.step_percent_end, `🏁 Ctrl "${type}" Step % End`);
  }

  is_field_is_compatible_to_sync_with(other: FIELD__base): boolean {
    if (!super.is_field_is_compatible_to_sync_with(other)) return false;

    return this.meta.node_family == other.meta.node_family;
  }

  @DECORATOR__field_is_input()
  @DECORATOR__field_not_linked()
  store__serialization_keys_list_white_for_hash(): string[] {
    let out: (keyof this)[] = ['type', 'image', 'model', 'weight', 'step_percent_begin', 'step_percent_end', 'control_mode'];

    return out as string[];
  }
}
